import React from 'react';

export const parseTextWithHTML = (
  text: string,
  linkClassName?: string
): React.ReactNode => {
  if (!text) return null;
  const allowedTags = ['B', 'STRONG', 'SUP', 'I', 'EM', 'A', 'U'];
  const normalizedText = text
    .replace(/\\n|\n/g, '<br/>')
    .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
    .replace(/<link\s+url=['"]([^'"]+)['"]>/gi, '<a href="$1">')
    .replace(/<link>(.*?)<\/link>/gi, (match, p1) => {
      const url = p1.trim();
      return `<a href="${url}">${p1}</a>`;
    });

  const DOMParserClass = (globalThis as any).DOMParser;
  const NodeClass = (globalThis as any).Node;

  if (typeof DOMParserClass !== 'function' || typeof NodeClass === 'undefined') {
    return normalizedText
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<a\s+href=['"]([^'"]+)['"]>(.*?)<\/a>/gi, (_match, href, content) => {
        const url = href.startsWith('http') ? href : `https://${href}`;
        return `${content} (${url})`;
      });
  }

  const parser = new DOMParserClass();
  const doc = parser.parseFromString(normalizedText, 'text/html');
  const traverse = (node: ChildNode, key: number): React.ReactNode => {
    if (node.nodeType === NodeClass.TEXT_NODE) return node.textContent;
    if (node.nodeType === NodeClass.ELEMENT_NODE) {
      const element = node as HTMLElement;
      if (element.tagName === 'BR') return <br key={key} />;
      if (!allowedTags.includes(element.tagName)) return element.textContent;
      const children = Array.from(element.childNodes).map((child, i) =>
        traverse(child, i)
      );
      switch (element.tagName) {
        case 'B':
        case 'STRONG':
          return <strong key={key}>{children}</strong>;
        case 'I':
        case 'EM':
          return <em key={key}>{children}</em>;
        case 'SUP':
          return <sup key={key}>{children}</sup>;
        case 'U':
          return <u key={key}>{children}</u>;
        case 'A': {
          let url = element.getAttribute('href') || '';
          if (!url) {
            const textContent = element.textContent?.trim() || '';
            if (textContent && !textContent.includes(' ')) {
              url = textContent;
            }
          }
          if (url && !url.startsWith('http')) {
            url = `https://${url}`;
          }
          return (
            <a
              key={key}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className={linkClassName}
            >
              {children}
            </a>
          );
        }
        default:
          return children;
      }
    }
    return null;
  };
  return Array.from(doc.body.childNodes).map((node, index) =>
    traverse(node as ChildNode, index)
  );
};

// web superscript function
export const addSuperscriptText = (text: string): React.ReactNode => {
  if (text === null || text === undefined) return text;
  const safeText = typeof text === 'string' ? text : String(text);
  const preReplaced = safeText
    .replace(/MD/g, '<sup>MD</sup>')
    .replace(/®/g, '<sup>®</sup>');
  return parseTextWithHTML(safeText, 'text-[#2F6FA7] hover:underline');
};

export function renderDescriptionParagraphs(
  desc: string,
  customClass?: string
): React.ReactNode;
export function renderDescriptionParagraphs(
  desc: string,
  customClass: string | undefined,
  textOnly: true
): string;
export function renderDescriptionParagraphs(
  desc: string,
  customClass?: string,
  textOnly?: boolean
): React.ReactNode | string {
 const normalizedDesc = Array.isArray(desc) ? desc.join(' ') : String(desc ?? '');
  if (textOnly) {
    
    return normalizedDesc?.replace(/<[^>]*>/g, '')
      ?.replace(/\s+/g, ' ')
      ?.trim();
  }

  const parts = normalizedDesc?.split(/\n/);
 
  return parts?.map((part, idx) => (
    <p key={idx} aria-label={part} className={customClass}>
      {addSuperscriptText(part)}
    </p>
  ));
}


